import { useRef, useEffect } from 'react';
import TileArcGISRestSource from 'ol/source/TileArcGISRest';
import OLTileLayer from 'ol/layer/Tile';
import TileGrid from 'ol/tilegrid/TileGrid';
import { createXYZ } from 'ol/tilegrid';
import { useOLMap } from '../MapContext';
import { useLayerEffect } from './useLayerEffect';
import { getCrossOriginValue } from './getCrossOriginValue';
export const TileArcGISRestLayer = (props) => {
    const map = useOLMap();
    const layerRef = useRef();
    useLayerEffect(layerRef, props.layerOptions);
    useEffect(() => {
        const projection = map.getView().getProjection();
        let tileGrid = undefined;
        if (props.gridParams && props.gridParams.resolutions && props.gridParams.origin) {
            tileGrid = new TileGrid({
                origin: props.gridParams.origin,
                resolutions: props.gridParams.resolutions,
                tileSize: props.gridParams.tileSize,
            });
        }
        else if (props.gridParams && props.gridParams.extent) {
            tileGrid = createXYZ({
                extent: props.gridParams.extent,
                tileSize: props.gridParams.tileSize,
            });
        }
        const sourceParams = {
            ...props.sourceOptions,
            projection,
            crossOrigin: getCrossOriginValue(props.sourceOptions.url),
            wrapX: projection.isGlobal(),
            tileGrid,
            tileLoadFunction: (imageTile, src) => {
                imageTile.getImage().src = src;
            },
        };
        const layer = new OLTileLayer({
            source: new TileArcGISRestSource(sourceParams),
            visible: props.layerOptions.visible,
            opacity: props.layerOptions.opacity ?? 1,
            minResolution: props.layerOptions.minResolution,
            maxResolution: props.layerOptions.maxResolution,
            zIndex: props.layerOptions.zIndex,
        });
        layerRef.current = layer;
        map.addLayer(layer);
        if (process.env.NODE_ENV === 'development') {
            console.debug('new TileArcGISRestLayer', map, layerRef.current);
        }
        return () => {
            // unmount
            const layer = layerRef.current;
            if (layer) {
                map.removeLayer(layer);
                layer.dispose();
                layerRef.current = null;
            }
        };
    }, [map, props.sourceOptions]);
    return null;
};
//# sourceMappingURL=TileArcGISRestLayer.js.map